<template>
  <div class="history-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.change_pwd') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.change_pwd') }}</div>
    <Step :step="stepIndex" :steparr="$t('change_pwd_page.step')"/>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="changePwd"/>
      </div>
      <div class="page-right step-content">
        <div class="step-content-item" :class="{ active:stepIndex==1 }">
          <div class="form-desc" style="text-align:left;margin-top:0px;">{{ $t('change_pwd_page.insert_mobile') }}</div>
          <div class="form">
            <div class="form-item">
              <div class="form-title required">{{ $t('change_pwd_page.mobile') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('change_pwd_page.mobile_placeholder')" v-model="formData.phone.value">
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('change_pwd_page.email_or_account') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('change_pwd_page.email_or_account_placeholder')" v-model="formData.account.value">
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('change_pwd_page.verify_code') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-3 group-with-btn">
                  <input type="text" :placeholder="$t('change_pwd_page.verify_code_placeholder')" v-model="formData.code.value">
                  <div 
                    class="btn btn-orange get-code-btn" 
                    @click="handleGetCode"
                    :disabled="getingCode"
                  >{{ $t('btns.get_verify_code') }}{{ getingCode?`(${countNumber})`:'' }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="btns flex">
            <div class="btn btn-orange next-step" @click="next">{{ $t('btns.confirm') }}</div>
          </div>
        </div>

        <div class="step-content-item" :class="{ active:stepIndex==2 }">
          <div class="form-desc" style="text-align:left;margin-top:0px;">{{ $t('change_pwd_page.please_reset_pwd') }}</div>
          <div class="form">
            <div class="form-item">
              <div class="form-title required">{{ $t('change_pwd_page.old_pwd') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" placeholder="$t('change_pwd_page.old_pwd_placeholder')" v-model="formData2.old_pwd.value">
                </div>
              </div>
            </div>
            <div class="form-item"> 
              <div class="form-title required">{{ $t('change_pwd_page.new_pwd') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" placeholder="$t('change_pwd_page.new_pwd_placeholder')" v-model="formData2.new_pwd.value">
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('change_pwd_page.new_pwd2') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" placeholder="$t('change_pwd_page.new_pwd2_placeholder')" v-model="formData2.new_pwd2.value">
                </div>
              </div>
            </div>
          </div>
          <div class="btns flex">
            <div class="btn btn-orange next-step" @click="next">{{ $t('btns.confirm') }}</div>
          </div>
        </div>
        <div class="step-content-item" :class="{ active:stepIndex=='3' }">
          <div class="success-content">{{ $t('change_pwd_page.change_success') }}</div>
          <div class="btn btn-orange next-step" @click="next">{{ $t('btns.confirm') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userSideMenu from '@/components/UserSideMenu'
import Step from '@/components/Step/index.vue'
import { changePWD, getCode, verifyCode }  from '@/api/index.js'
import { del } from '../../utils/localStorage.js'
  export default {
    name: 'change-pwd',
    data: () => {
      return {
        stepIndex: 1,
        formData: {
          phone: { required: true, value:'' },
          account: { required: true, value:'' },
          code: { required: true, value:'' },
        },
        formData2: {
          old_pwd: { required: true, value:'' },
          new_pwd: { required: true, value:'' },
          new_pwd2: { required: true, value:'' },
        },
        verifyCodeString: '',
        getingCode: false,
        countNumber: 60,
        countNumberDefaul: 60, // 取得验证码的倒数设定值
      }
    },
    components: {
      userSideMenu,Step
    },
    methods: {
      next() {
        if(this.stepIndex==1) {
          this.checkCode();
        }else if(this.stepIndex==2){
          this.changePWD();
        }else{
          // this.stepIndex=1;
          // 登出
          del('token');
          del('userInfo');
          this.$store.commit('CLEAN_USER_INFO');
          this.$router.push({ name: 'register', query: { type: 'login' } });
        }
      },
      async handleGetCode() {
        if(this.getingCode) return;
        if(this.formData.phone.value=='') {
          this.$message({
            message: this.$t('alert_message.enter_mobile'),
            type: 'warning'
          });
          return;
        }
        const loadingInstance = this.$loading();
        try {
          await getCode({ mobile:this.formData.phone.value });
          loadingInstance.close();
          this.$message({
            message: this.$t('alert_message.send_success'),
            type: "success",
          })
          this.countNumber = this.countNumberDefaul;
          this.getingCode = true;
          const countingInterval = setInterval(() => {
            if(this.countNumber==0){
              this.getingCode = false;
              clearInterval(countingInterval);
            }
            this.countNumber--;
          }, 1000);
        } catch (error) {
          console.log(error);
          loadingInstance.close();
          // this.$message({
          //   message: "发送失败！",
          //   type: "error",
          // })
        }
      },
      async checkCode() {
        const check = this.checkForm(this.formData);
        if(check) {
          // 去判断code是否正确
          try {
            const res = await verifyCode({ mobile: this.formData.phone.value, code: this.formData.code.value });
            // verification==1 通过
            if(res.verification==1) {
              this.stepIndex = 2;    
            }else{
              this.$message({
                message: this.$t('alert_message.error_verify_code'),
                type: "error",
              });
            }
          } catch (error) {
            this.$message({
              message: this.$t('alert_message.error_verify_code'),
              type: "error",
            });
          }
          
          
        }else{
          this.$message({
            message: this.$t('alert_message.has_empty_input'),
            type: "warning",
          });
        }
      },
      async changePWD() {
        const check = this.checkForm(this.formData2);
        if(this.formData2.new_pwd.value!=this.formData2.new_pwd2.value) {
          this.$message({
            message: this.$t('alert_message.pwd_is_not_same'),
            type: "warning",
          });
          return;
        }
        if(check) {
          // 送出更改密码的需求
          const loadingInstance = this.$loading();
          try {
            const res = await changePWD({ old_pwd:this.formData2.old_pwd.value, new_pwd:this.formData2.new_pwd.value });
            loadingInstance.close();
            console.log('res',res);
            if(res.status=='OK') {
              this.stepIndex = 3;
            }else{
              this.$message({
                message: this.$t('alert_message.some_error'),
                type: "error",
              });  
            }
          } catch (error) {
            loadingInstance.close();  
          }
        }else{
          this.$message({
            message: this.$t('alert_message.has_empty_input'),
            type: "warning",
          });
        }
      },
      checkForm(formData) {
        let isEmpty = false;
        for (const key in formData) {
          if (formData.hasOwnProperty(key)) {
            const element = formData[key];
            if(element.value=='') isEmpty=true;
          }
        }
        if(isEmpty) {
          return false
        }else{
          return true;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
@import '../../common/style/form.less';
.history-page {
  .get-code-btn {
    margin: 0;
  }
  .group-with-btn {
    input {
      flex: 0 0 66.666%;
    }
    .btn {
      flex: 1;
    }
    @media (max-width: 992px) {
      input {
        margin-right: 0 !important;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
        flex: 1;
      }
      .btn {
        border-top-right-radius: 6px !important;
        border-bottom-right-radius: 6px !important;
        background: #A72121;
        flex: 0 0 100px
      }
    }
  }
}
</style>